module.exports = __webpack_public_path__ + "static/media/computer-speaker.d6953a33.svg";